'use client';

import type { Path } from '@ahm/api-wrappers-core';
import type { ButtonProps } from '@mantine/core';
import { memo } from 'react';
import PathBtn from './path-btn';
import PathEditable from './path-editable';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';

type Props = ButtonProps & {
  path?: Path;
  pathIndex: number;
};

function PathItem({ path, pathIndex }: Props) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <PathBtn path={path} pathIndex={pathIndex} />;
  }

  return <PathEditable path={path} pathIndex={pathIndex} />;
}

export default memo(PathItem);
